/* ================================================================
   8TH SIN — CAROUSEL VAULT JS  v5
   Fixed:
   - Drag direction (was reversed)
   - dragMove uses saved rotY at drag start (no drift)
   - Multiplier reduced 0.38 → 0.15 (natural feel)
   - Snap formula corrected (no erroneous negation)
   - Touch: horizontal-only, vertical scroll passes through
   ================================================================ */

(function () {
  'use strict';

  const stage      = document.getElementById('cvStage');
  const dotsWrap   = document.getElementById('cvDots');
  const infoName   = document.getElementById('cvInfoName');
  const infoPrice  = document.getElementById('cvInfoPrice');
  const viewBtn    = document.getElementById('cvViewBtn');
  const currentEl  = document.getElementById('cvCurrent');
  const hintEl     = document.getElementById('cvHint');
  const ambientEl  = document.getElementById('cvAmbient');
  const qvEl       = document.getElementById('cvQv');
  const qvBackdrop = document.getElementById('cvQvBackdrop');
  const qvClose    = document.getElementById('cvQvClose');
  const qvImg      = document.getElementById('cvQvImg');
  const qvName     = document.getElementById('cvQvName');
  const qvPrice    = document.getElementById('cvQvPrice');
  const qvSizes    = document.getElementById('cvQvSizes');
  const qvAdd      = document.getElementById('cvQvAdd');
  const qvFull     = document.getElementById('cvQvFull');
  const menuBtn    = document.getElementById('cvMenuBtn');
  const menuEl     = document.getElementById('cvMenu');
  const menuClose  = document.getElementById('cvMenuClose');

  if (!stage) return;

  const cards = Array.from(stage.querySelectorAll('.cv-card'));
  const N = cards.length;
  if (!N) return;

  let currentIdx    = 0;
  let rotY          = 0;
  let targetRotY    = 0;
  let isDragging    = false;
  let dragStartX    = null;
  let dragStartRotY = null; // FIX: save rotY at drag start to prevent drift
  let hintHidden    = false;
  let autoTimer     = null;
  let selectedSize  = null;

  // Touch direction lock
  let touchStartX = null;
  let touchStartY = null;
  let touchLocked = null; // 'drag' | 'scroll' | null

  const STEP      = 360 / N;
  const RADIUS_VW = Math.min(window.innerWidth * 1.05, 560);
  const DRAG_SENS = 0.65; // FIX: was 0.38 — much more natural now

  /* ── BUILD DOTS ── */
  cards.forEach((_, i) => {
    const dot = document.createElement('div');
    dot.className = 'cv-dot-item' + (i === 0 ? ' active' : '');
    dot.setAttribute('role', 'button');
    dot.setAttribute('tabindex', '0');
    dot.setAttribute('aria-label', `Product ${i + 1}`);
    dot.style.cssText = 'z-index:200;position:relative;';
    dot.addEventListener('click', () => { stopAuto(); goTo(i); hideHint(); });
    dot.addEventListener('keydown', e => { if (e.key === 'Enter') goTo(i); });
    dotsWrap.appendChild(dot);
  });
  const dots = dotsWrap.querySelectorAll('.cv-dot-item');

  /* ── PLACE CARDS ── */
  function placeCards() {
    cards.forEach((card, i) => {
      const rel   = ((STEP * i - rotY) % 360 + 360) % 360;
      const rad   = rel * Math.PI / 180;
      const sinV  = Math.sin(rad);
      const cosV  = Math.cos(rad);
      const x     = sinV * RADIUS_VW;
      const z     = (cosV - 1) * RADIUS_VW * 0.5;
      const scale = 0.74 + (cosV + 1) * 0.13; // 0.74 → 1.0

      card.style.transform = `translateX(${x}px) translateZ(${z}px) scale(${scale})`;
      card.style.opacity   = 1;
      card.style.zIndex    = Math.round((cosV + 1) * 10);
      card.classList.toggle('is-active', i === currentIdx);
    });
  }

  /* ── GO TO ── */
  function goTo(idx, instant) {
    idx = ((idx % N) + N) % N;
    currentIdx = idx;

    let t = STEP * idx;
    // Take shortest arc to target
    while (t - rotY >  180) t -= 360;
    while (rotY - t >  180) t += 360;
    targetRotY = t;

    if (instant) { rotY = t; placeCards(); }

    const card = cards[idx];

    // Smooth name transition
    infoName.style.transition  = 'opacity 0.16s ease, transform 0.16s ease';
    infoPrice.style.transition = 'opacity 0.16s ease';
    infoName.style.opacity     = '0';
    infoName.style.transform   = 'translateY(-6px)';
    infoPrice.style.opacity    = '0';

    setTimeout(() => {
      infoName.textContent      = card.dataset.name  || '';
      infoPrice.textContent     = card.dataset.price || '';
      infoName.style.transition = 'none';
      infoName.style.transform  = 'translateY(8px)';
      requestAnimationFrame(() => requestAnimationFrame(() => {
        infoName.style.transition  = 'opacity 0.2s ease, transform 0.2s ease';
        infoPrice.style.transition = 'opacity 0.2s ease';
        infoName.style.opacity     = '1';
        infoName.style.transform   = 'translateY(0)';
        infoPrice.style.opacity    = '1';
      }));
    }, 170);

    if (viewBtn)   viewBtn.onclick       = () => window.location.href = card.dataset.url || '#';
    if (currentEl) currentEl.textContent = idx + 1;
    dots.forEach((d, i) => d.classList.toggle('active', i === idx));
    updateAmbient(card.dataset.glow || '#3a3a6a');
  }

  /* ── AMBIENT GLOW ── */
  function updateAmbient(hex) {
    if (!ambientEl) return;
    ambientEl.style.background =
      `radial-gradient(ellipse 70% 55% at 50% 52%, ${hex}28 0%, transparent 72%)`;
  }

  /* ── ANIMATION LOOP ── */
  function animate() {
    const diff = targetRotY - rotY;
    rotY += Math.abs(diff) > 0.015 ? diff * 0.10 : diff;
    placeCards();
    requestAnimationFrame(animate);
  }

  /* ── DRAG HELPERS ── */
  function dragStart(x) {
    dragStartX    = x;
    dragStartRotY = rotY; // FIX: snapshot current rotY — prevents drift
    isDragging    = true;
    stage.classList.add('dragging');
    stopAuto();
    hideHint();
  }

  function dragMove(x) {
    if (!isDragging || dragStartX === null) return;
    // FIX: subtract (drag right = previous card, drag left = next card)
    // FIX: use dragStartRotY not live rotY — prevents accumulation drift
    targetRotY = dragStartRotY - (x - dragStartX) * DRAG_SENS;
  }

  function dragEnd() {
    if (!isDragging) return;
    isDragging    = false;
    dragStartX    = null;
    dragStartRotY = null;
    stage.classList.remove('dragging');

    // FIX: snap formula — find nearest card, no negation
    const nearest = Math.round(rotY / STEP);
    const idx     = ((nearest % N) + N) % N;
    goTo(idx);
  }

  /* ── MOUSE DRAG ── */
  stage.addEventListener('mousedown', e => {
    e.preventDefault();
    dragStart(e.clientX);
  });
  window.addEventListener('mousemove', e => { if (isDragging) dragMove(e.clientX); });
  window.addEventListener('mouseup',   dragEnd);

  /* ── TOUCH DRAG (horizontal only, vertical passes through) ── */
  stage.addEventListener('touchstart', e => {
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
    touchLocked = null;
  }, { passive: true });

  window.addEventListener('touchmove', e => {
    if (touchStartX === null) return;
    const dx = Math.abs(e.touches[0].clientX - touchStartX);
    const dy = Math.abs(e.touches[0].clientY - touchStartY);

    if (touchLocked === null && (dx > 8 || dy > 8)) {
      touchLocked = dx > dy ? 'drag' : 'scroll';
    }

    if (touchLocked === 'drag') {
      if (!isDragging) dragStart(touchStartX);
      dragMove(e.touches[0].clientX);
    }
    // 'scroll' — let browser handle vertically
  }, { passive: true });

  window.addEventListener('touchend', () => {
    if (touchLocked === 'drag') dragEnd();
    touchStartX = null;
    touchStartY = null;
    touchLocked = null;
  });

  /* ── HORIZONTAL TRACKPAD SCROLL (desktop only) ── */
  const isFinitePointer = window.matchMedia('(pointer: fine)').matches;
  const WHEEL_SENS = 0.18;  // tune: higher = more responsive
  let wheelSnapTimer = null;

  if (isFinitePointer) {
    window.addEventListener('wheel', e => {
      const absX = Math.abs(e.deltaX);
      const absY = Math.abs(e.deltaY);

      // Only act on predominantly horizontal movement
      if (absX < 3 && absY > absX) return;
      if (absX < absY * 0.4) return;

      e.preventDefault();
      stopAuto();
      hideHint();

      // Accumulate smoothly — same direction logic as drag
      targetRotY += e.deltaX * WHEEL_SENS;

      // After scrolling stops, snap to nearest card
      clearTimeout(wheelSnapTimer);
      wheelSnapTimer = setTimeout(() => {
        const nearest = Math.round(rotY / STEP);
        const idx = ((nearest % N) + N) % N;
        goTo(idx);
      }, 160);

    }, { passive: false });
  }

  /* ── TAP CARD ── */
  stage.addEventListener('click', e => {
    if (isDragging) return;
    const card = e.target.closest('.cv-card');
    if (!card) return;
    const idx = parseInt(card.dataset.index, 10);
    if (idx !== currentIdx) { goTo(idx); return; }
    openQV(card);
  });

  /* ── AUTO ROTATE ── */
  function startAuto() {
    stopAuto();
    autoTimer = setInterval(() => { if (!isDragging) goTo(currentIdx + 1); }, 4000);
  }
  function stopAuto() {
    if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
  }

  /* ── HINT ── */
  function hideHint() {
    if (hintHidden || !hintEl) return;
    hintHidden = true;
    hintEl.classList.add('hidden');
  }

  /* ── QUICK VIEW ── */
  function openQV(card) {
    hideHint(); stopAuto();
    qvName.textContent  = card.dataset.name  || '';
    qvPrice.textContent = card.dataset.price || '';
    if (qvFull) qvFull.href = card.dataset.url || '#';

    const cardImg = card.querySelector('.cv-card-img');
    if (cardImg && qvImg) {
      qvImg.src = cardImg.src.replace('_600x900', '_800x1200');
      qvImg.alt = card.dataset.name || '';
    }

    qvSizes.innerHTML = ''; selectedSize = null;
    const variants  = (card.dataset.variants || '').split(',').filter(Boolean);
    const showSizes = variants.length > 1 || (variants.length === 1 && variants[0].toLowerCase() !== 'default title');
    if (showSizes) {
      variants.forEach(v => {
        const btn = document.createElement('button');
        btn.className   = 'cv-size-btn';
        btn.textContent = v.trim();
        btn.addEventListener('click', () => {
          qvSizes.querySelectorAll('.cv-size-btn').forEach(b => b.classList.remove('selected'));
          btn.classList.add('selected');
          selectedSize = v.trim();
        });
        qvSizes.appendChild(btn);
      });
    }

    qvAdd.textContent = 'Add to Cart';
    qvAdd.classList.remove('added', 'loading');
    qvAdd.disabled = false;
    qvEl.classList.add('open');
    qvEl.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeQV() {
    qvEl.classList.remove('open');
    qvEl.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    startAuto();
  }

  if (qvClose)    qvClose.addEventListener('click', closeQV);
  if (qvBackdrop) qvBackdrop.addEventListener('click', closeQV);
  window.addEventListener('keydown', e => {
    if (qvEl && qvEl.classList.contains('open')) { if (e.key === 'Escape') closeQV(); return; }
    if (e.key === 'ArrowLeft')  goTo(currentIdx - 1);
    if (e.key === 'ArrowRight') goTo(currentIdx + 1);
  });

  /* ── AJAX ADD TO CART ── */
  qvAdd && qvAdd.addEventListener('click', async () => {
    const card = cards[currentIdx];
    if (!card) return;
    qvAdd.textContent = 'Adding…'; qvAdd.classList.add('loading'); qvAdd.disabled = true;
    try {
      const prod = await fetch(`${card.dataset.url}.js`).then(r => r.json());
      let variantId = prod.variants[0]?.id;
      if (selectedSize && prod.variants.length > 1) {
        const match = prod.variants.find(v => v.title === selectedSize);
        if (match) variantId = match.id;
      }
      const cartRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (!cartRes.ok) throw new Error();
      const cartData = await fetch('/cart.js').then(r => r.json());
      document.querySelectorAll('.cart-count,.cv-cart-count').forEach(el => { el.textContent = cartData.item_count; });
      qvAdd.textContent = 'Added ✓'; qvAdd.classList.remove('loading'); qvAdd.classList.add('added');
      showToast(card.dataset.name);
      setTimeout(() => { qvAdd.textContent = 'Add to Cart'; qvAdd.classList.remove('added'); qvAdd.disabled = false; }, 2500);
    } catch {
      qvAdd.textContent = 'Try Again'; qvAdd.classList.remove('loading'); qvAdd.disabled = false;
    }
  });

  function showToast(name) {
    let t = document.querySelector('.cv-added-toast');
    if (!t) { t = document.createElement('div'); t.className = 'cv-added-toast'; document.body.appendChild(t); }
    t.textContent = `${name ? name.split(' ')[0] : 'Item'} added to cart`;
    t.classList.add('show');
    setTimeout(() => t.classList.remove('show'), 2800);
  }

  /* ── MENU ── */
  menuBtn   && menuBtn.addEventListener('click',   () => { menuEl.classList.add('open');    menuEl.setAttribute('aria-hidden', 'false'); });
  menuClose && menuClose.addEventListener('click', () => { menuEl.classList.remove('open'); menuEl.setAttribute('aria-hidden', 'true');  });

  /* ── INIT ── */
  goTo(0, true); startAuto(); animate();

  fetch('/cart.js').then(r => r.json()).then(d => {
    document.querySelectorAll('.cart-count,.cv-cart-count').forEach(el => { el.textContent = d.item_count; });
  }).catch(() => {});

})();
